import React, { useState } from "react";

const SelectOwnerModal = ({ isOpen, onClose, members, onConfirm }) => {
  const [selectedOwnerId, setSelectedOwnerId] = useState(null);

  if (!isOpen) {
    return null;
  }

  const handleConfirm = () => {
    if (!selectedOwnerId) {
      alert("Please select a new owner");
      return;
    }
    onConfirm(selectedOwnerId);
  };

  const handleClose = () => {
    setSelectedOwnerId(null);
    onClose();
  };

  return (
    <div
      className="artist-profile-modal-overlay"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) handleClose();
      }}
    >
      <div
        className="artist-profile-modal groups-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="artist-profile-modal-header">
          <h2>Select New Owner</h2>
          <button
            type="button"
            className="artist-profile-modal-close"
            aria-label="Close"
            onClick={handleClose}
          >
            ×
          </button>
        </div>

        <div className="artist-profile-modal-body groups-modal-body">
          <div className="groups-modal-section">
            <p className="groups-modal-description">
              You are leaving this artist group as the owner. Please select a member to become the new owner.
            </p>
          </div>

          <div className="groups-modal-section">
            <h3 className="groups-modal-section-title">Select New Owner</h3>
            <div className="groups-modal-members">
              {members.map((member) => (
                <div
                  key={member.user_id}
                  className={`groups-modal-member-tile ${
                    selectedOwnerId === member.user_id ? "selected" : ""
                  }`}
                  onClick={() => setSelectedOwnerId(member.user_id)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="groups-modal-member-info">
                    <span className="groups-modal-member-name">
                      {member.name || member.email}
                    </span>
                    {member.role === "member" && (
                      <span className="groups-modal-member-role">Member</span>
                    )}
                  </div>
                  {selectedOwnerId === member.user_id && (
                    <span className="groups-modal-member-role" style={{ marginTop: "0.5rem" }}>
                      ✓ Selected
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="groups-modal-section">
            <div className="groups-modal-actions">
              <button
                type="button"
                className="groups-modal-primary-button"
                onClick={handleConfirm}
                disabled={!selectedOwnerId}
              >
                Confirm
              </button>
              <button
                type="button"
                className="groups-modal-secondary-button"
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectOwnerModal;
